import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserStateService } from '../services/user-state-service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const userStateService = inject(UserStateService);

  const withTokenHeader = req.clone({
    setHeaders: {
      Authorization: makeBearerToken(userStateService),
    },
  });

  console.debug('Intercepting HTTP request:', withTokenHeader);
  return next(withTokenHeader);
};

type TokenType = {
  kaz: string;
  znr?: string;
}

function makeBearerToken(state: UserStateService) {
  const token: TokenType = {
    kaz: state.kassenzeichen,
    znr: state.zaehlernummer.length > 0 ? state.zaehlernummer : undefined,
  };

  const tokenString = JSON.stringify(token);
  const tokenBase64 = btoa(tokenString);

  return `Bearer ${tokenBase64}`;

}
